import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../Pages/Shared/Header";
import SubNavBar from "../../Pages/Shared/SubNavBar";
import { useEffect, useState } from "react";
import HeaderManager from "../../Pages/Shared/HeaderManager";
import SubNavBarManager from "../../Pages/Shared/SubNavBarManager";

const MainLayoutManager = ({ children }) => {
  let location = useLocation();
  const navigate = useNavigate();
  const showNan = location.pathname.split("/").includes("ViewApplication");
  const [showNanManger, setshowNanManger] = useState(true);
  const params = new URLSearchParams(window.location.search);

  // Get the value of "token"
  const token = params.get("token");
  console.log(showNan, "sssasdasdasdsssssssssssdwd", location.pathname);

  useEffect(() => {
    // if(sessionStorage.getItem("AccessTokenManager")!==null&&(token!=null||token!=undefined)&&window.location.pathname.includes("manager")===true){
    //   navigate("/researcher/manager/ActionOnApplications/");
    // }
    // if(sessionStorage.getItem("AccessTokenManager")!==null&&(token!=null||token!=undefined)&&window.location.pathname.includes("manager")===true){
    //   navigate("/researcher/manager/ActionOnApplications/");
    // }
    // console.log(token,"ddddddddddddsdwwwwwddddddddddd");

    if (
      sessionStorage.getItem("AccessTokenManager") !== null &&
      (token != null || token != undefined)
    ) {
      console.log("ddddddddddddddddddfef");

      // navigate("/researcher/manager/ActionOnApplications/");
    }
    if (window.opener) {
      setshowNanManger(false);
    } else {
      setshowNanManger(true);
    }
  }, []);
  return (
    <>
      <HeaderManager />
      {showNan ? <SubNavBar /> : showNanManger ? <SubNavBarManager /> : ""}
      <main>{children}</main>
    </>
  );
};
export default MainLayoutManager;
